// test2541
(2541 && 0);
